import _merge from 'lodash/merge';
import MerchantWidgetSessionUtils from 'moet-test-utils/e2e/merchant-widget-session.utils';
import { WIDGET_ONBOARDING_TYPE_MAP, WIDGET_TYPE } from 'moet-core/src/constants';

export const createWidgetMerchant = async params => {
  const {
    baseUrl,
    country,
    widgetType,
    environment,
    region,
    variant = [],
    platform,
    prefillInformation,
    documentTypes,
    contractOnboardingType,
    merchantData: passedMerchantData,
  } = params;

  const widgetSession = new MerchantWidgetSessionUtils(environment, region, widgetType);
  const merchantOptions = {
    country,
    platform,
    addPrefill: widgetType === WIDGET_TYPE.MANAGED_RISK,
    variant,
    contractOnboardingType,
    prefillInformation,
    convertToSnakeCase: false,
    merchantForTest: {
      platform,
      country,
    },
  };
  const merchantData = widgetSession.defineMerchantForWidget(merchantOptions, widgetType);

  const merchant = await widgetSession.createWidgetMerchant(
    merchantData,
    { skipFakeTransactions: false },
    { widgetType, contractOnboardingType },
    {
      overrideUrl: baseUrl,
    },
  );

  if (
    (variant?.length || passedMerchantData) &&
    ![WIDGET_TYPE.MANAGED_RISK, WIDGET_TYPE.MANAGED_SME_RISK].includes(widgetType)
  ) {
    const onboardingType = WIDGET_ONBOARDING_TYPE_MAP[widgetType];
    const data = _merge(_merge(merchant, merchantData), passedMerchantData);

    if (!data.products) {
      data.products = [];
    }

    await widgetSession
      .updateMerchant(data, onboardingType, { overrideUrl: baseUrl })
      .catch(console.error);
  }

  return await widgetSession.getWidgetUrl(
    merchant,
    {
      widgetType,
      contractOnboardingType,
      ...(prefillInformation ? { prefillInformation } : {}),
      ...(documentTypes ? { documentTypes: JSON.stringify(documentTypes) } : {}),
    },
    {
      overrideUrl: baseUrl,
    },
  );
};
